<template>
  <div class="text-center loading-container" width="100%">

    <v-progress-circular
      :size="size"
      :width="7"
      color="primary"
      indeterminate
    ></v-progress-circular>

  </div>
</template>

<script>
  export default {
    name: 'LoadingContainer',

    props: {
      size: {
        type: Number,
        default: 70,
      }
    },


    methods: {

    }
  }
</script>

<style lang="scss" scoped>

  .v-progress-circular {
    margin: 1rem;
  }

  .loading-container {
    width: 100%;
  }

</style>
